import { Pagination } from "src/app/core/utils/pagination.entity";
import { UserData } from "./user-data.entity";

export abstract class UserPagination extends Pagination<UserData[]> {}
